import { RotateCw } from "lucide-react";

export default function ReloadButton() {
    function realodPage() {
        window.location.reload();
    }
    return (
        <button
            onClick={realodPage}
            className={`
          absolute z-10 right-4 bottom-8 md:right-8
          flex items-center justify-center
          w-10 h-10
          bg-gradient-to-r
        from-blue-600 to-blue-500
        hover:from-blue-700 hover:to-blue-600
          text-white
          rounded-full
          shadow-md shadow-gray-400
          transition-all duration-300
          transform hover:scale-105
          focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 
        `}
        >
            <RotateCw className="w-6 h-6" />
        </button>
    )
}